import useTreeBase from '@teams/common/hooks/useTreeBase'
import type { IBaseConfig, INodeItem } from '@teams/common/hooks/useTreeBase'
import { computed, ComputedRef } from 'vue'
export default function ({
  nodeLoadedStatus,
  expandedKeys
}: {
  nodeLoadedStatus: Record<string, boolean>
  expandedKeys: ComputedRef<string[]>
}) {
  const nodeChildrenMap: WeakMap<INodeItem, string> = new WeakMap()
  const config: IBaseConfig = {
    defaultQuery: {
      ignore: 'file',
      linkgroup: true
    },
    hook: {
      formatNode(node: INodeItem): INodeItem {
        const { key } = node
        // 对展开的子节点设置children
        if (expandedKeys.value.includes(key)) {
          nodeManager.setNodeChildren(node)
        }
        return node
      }
    }
  }
  const {
    topMenus,
    childrenMap,
    getTopMenus,
    fetchChildren,
    loadMoreChildren,
    findNodeByKey
  } = useTreeBase(config)

  const init = async ({ groupId, fid }: { groupId: string; fid?: string }) => {
    await getTopMenus({ groupId, fid })
  }
  const refreshChildren = async (key: string) => {
    const menu = childrenMap[key]
    if (!menu) {
      return
    }
    await menu.refresh()
  }
  const nodeManager = {
    // 用计算属性设置节点chilren
    setNodeChildren(node) {
      if (!nodeChildrenMap.get(node)) {
        const { key } = node
        nodeChildrenMap.set(node, key)
        node.children = computed<INodeItem[] | undefined>(() => {
          const { key } = node
          // 收起后 nodeLoadedStatus为false, 此时返回false使再展开时展示loading状态
          if (!nodeLoadedStatus[key]) {
            return undefined
          }
          return childrenMap[key].children || []
        })
      }
    },
    async getChildren(
      node,
      options: { reset?: boolean; refresh?: boolean } = {}
    ) {
      await fetchChildren(node, options)
    },
    rename(key, value) {
      const node = findNodeByKey(key)
      node && (node.label = value)
    },
    remove(keys: string[] = []) {
      keys.forEach(key => {
        const node = findNodeByKey(key)
        const mapItem = childrenMap[node?.parentKey || '']
        mapItem && mapItem.refresh()

        /* if (mapItem && mapItem.children) {
          mapItem.children = mapItem.children.filter(
            it => !keys.includes(it.key)
          )
        } */
      })
    }
  }
  return {
    topMenus,
    childrenMap,
    init,
    fetchChildren,
    loadMoreChildren,
    refreshChildren,
    findNodeByKey,
    nodeManager
  }
}
